import { AxiosRequestConfig } from 'axios';
import { apiClient } from './client';
import { withAuthorizationHeader } from './auth';
import { Rating } from '@/infrastructure/domain/product';

export type CreateRatingPayload = {
  marketId: string;
  productId: string;
  variantId: string;
  rating: number;
  comment?: string;
  attachments?: string[];
  productSnapshot: {
    quantity: number;
    sellingUnit: string;
  };
};

export const createRating = async (
  token: string,
  payload: CreateRatingPayload,
  opts: AxiosRequestConfig = {},
): Promise<Rating> => {
  const response = await apiClient.post<Rating>(
    '/v1/ratings',
    payload,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};
